export default "__VITE_ASSET__DzKeWcfr__"